<mat-card>
  <mat-card-title>Gym Finder information</mat-card-title>

  <mat-card-content>
    <div class="flex-row">
      <mat-card class="flex-grow card-spacer flex-50 mat-card-margin-bottom">
        <mat-card-content class="gym-details-content flex-display">
          <div class="info-section flex-grow">
            <gymfinder-basic-info
              [editMode]="editMode"
              [studioTypes]="studioTypes"
              [displayGymlibBackOfficeLink]="displayGymlibBackOfficeLink"
            [gym]="gym"></gymfinder-basic-info>
          </div>

          <div class="info-section flex-grow">
            <gymfinder-contact-info
              [gym]="gym"
            [editMode]="editMode"></gymfinder-contact-info>
          </div>
          <div class="info-section flex-grow">
            <mat-toolbar class="toolbar-subtitle">
              <mat-toolbar-row>Address</mat-toolbar-row>
            </mat-toolbar>
            <gymfinder-address-info
              [(address)]="gym.address"
            [editMode]="false"></gymfinder-address-info>
          </div>
        </mat-card-content>

        <mat-card-actions align="end">
          <button
            class="validate-address-btn"
            mat-raised-button
            color="primary"
            (click)="editAddress()"
            type="button"
            [disabled]="!editMode">
            Edit address
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="flex-row">
      <mat-card class="flex-grow flex-40 mat-card-margin-bottom">
        <mat-toolbar class="toolbar-subtitle">
          <mat-toolbar-row>Opening hours</mat-toolbar-row>
        </mat-toolbar>
        @if (!loading) {
          <mat-card-content>
            <mat-checkbox
              [checked]="sameForAllDays"
              [disabled]="!editMode"
              (change)="onSameForAllDaysChange($event.checked)"
              class="same-for-all-checkbox">
              Same for all days
            </mat-checkbox>
            @if (sameForAllDays) {
              <gymfinder-opening-hour
                [editMode]="editMode"
                day="monday"
                label="All days"
                [value]="getDayValue('monday')"
                (valueChange)="onAllDaysValueChange($event)">
              </gymfinder-opening-hour>
            } @else {
              @for (day of openingDays; track day) {
                <gymfinder-opening-hour
                  [editMode]="editMode"
                  [day]="day"
                  [value]="getDayValue(day)"
                  (valueChange)="onDayValueChange($event, day)">
                </gymfinder-opening-hour>
              }
            }
          </mat-card-content>
        }
        @if (!loading) {
          <mat-card-content class="mb-2em">
            <mat-form-field class="opening-hours-area">
              <mat-label>Opening hours explanation (Wellpass only) </mat-label>
              <textarea
                #openingHoursInfo="ngModel"
                [ngModel]="gym.openingHoursV2?.additionalInfo"
                (ngModelChange)="onAdditionalInfoTextChange($event)"
                [pattern]="openingHoursInfoTextPattern"
                matInput
                cdkTextareaAutosize
                [cdkAutosizeMinRows]="4"
                [cdkAutosizeMaxRows]="6"
                [maxlength]="openingHoursInfoMaxLength">
              </textarea>
              @if (openingHoursInfo.hasError('pattern')) {
                <mat-error>
                  Enter real text containing at least one letter or number.
                </mat-error>
              }
              <mat-hint align="end"
                >{{ openingHoursInfoLength }} /
                {{ openingHoursInfoMaxLength }} characters
              </mat-hint>
            </mat-form-field>
          </mat-card-content>
        }
        <mat-toolbar class="toolbar-subtitle">
          <mat-toolbar-row
            class="header-style"
            style="justify-content: flex-start">
            Exceptional opening hours
            <button
              mat-mini-fab
              style="margin-left: 16px"
              color="default"
              type="button"
              (click)="addException()"
              matTooltip="Add exceptional opening hours">
              <mat-icon color="secondary" aria-label="Add">add</mat-icon>
            </button>
          </mat-toolbar-row>
        </mat-toolbar>
        @if (!loading) {
          <mat-card-content class="mb-2em">
            <gymfinder-opening-hour
              day="publicHoliday"
              [editMode]="editMode"
              [value]="getDayValue('publicHoliday')"
              (valueChange)="onDayValueChange($event, 'publicHoliday')">
            </gymfinder-opening-hour>
            @if (
              gym.openingHoursV2?.exceptions &&
              gym.openingHoursV2.exceptions.length > 0
              ) {
              <div
                class="h4 specific-dates-header">
                Specific Dates
              </div>
            }
            @for (
              exception of gym.openingHoursV2?.exceptions; track
              exception; let i = $index) {
              <div>
                <gymfinder-exceptional-opening-hour
                  [exception]="exception"
                  [editMode]="editMode"
                  (exceptionChange)="onExceptionChange($event, i)"
                  (removeException)="onRemoveException(i)">
                </gymfinder-exceptional-opening-hour>
              </div>
            }
          </mat-card-content>
        }
        <gymfinder-external-booking-info
          [externalBookingInfo]="gym.externalBookingInfo"
          (externalBookingInfoChanged)="onExternalBookingInfoChanged($event)"
          [classBookingEnabled]="gym.classBookingConfig.enabled"
        [editMode]="true"></gymfinder-external-booking-info>
      </mat-card>
    </div>

    <gymfinder-attribute-change-schedule [gym]="gym" class="attribute-schedule">
    </gymfinder-attribute-change-schedule>

    <mat-card class="flex-grow flex-100 mat-card-margin-bottom">
      <mat-toolbar class="toolbar-subtitle no-margin-bottom">
        <mat-toolbar-row>Options</mat-toolbar-row>
      </mat-toolbar>

      <gymfinder-options
        [options]="gym.options"
        (optionsChange)="onOptionsChange($event)"
        [creditsConfig]="gym.creditsConfig"
        (creditsConfigChange)="onCreditsConfigChange($event)"
        [editMode]="editMode"
        [creditsFeatureFlag]="creditsFeatureFlag">
      </gymfinder-options>
    </mat-card>

    <mat-card class="flex-grow flex-100 mat-card-margin-bottom">
      <mat-toolbar class="toolbar-subtitle no-margin-bottom">
        <mat-toolbar-row>Additional Information</mat-toolbar-row>
      </mat-toolbar>
      <gymfinder-additional-info
        [(additionalInfo)]="gym.additionalInfo"
      [editMode]="true"></gymfinder-additional-info>
    </mat-card>

    <mat-card class="flex-grow flex-100 mat-card-margin-bottom">
      <mat-toolbar class="toolbar-subtitle no-margin-bottom">
        <mat-toolbar-row> Description</mat-toolbar-row>
      </mat-toolbar>
      <gymfinder-html-editor
        [(data)]="gym.description"
        [disabled]="!editMode"
        [maxChars]="800"></gymfinder-html-editor>

      <mat-toolbar class="toolbar-subtitle no-margin-bottom">
        <mat-toolbar-row> Qualitrain Description</mat-toolbar-row>
      </mat-toolbar>
      <gymfinder-html-editor
        [(data)]="gym.qualitrainOfferDescription"
      [disabled]="!editMode"></gymfinder-html-editor>

      <mat-toolbar class="toolbar-subtitle no-margin-bottom">
        <mat-toolbar-row>Access to the gym description</mat-toolbar-row>
      </mat-toolbar>
      <gymfinder-html-editor
        [(data)]="gym.accessDescription"
        [disabled]="!editMode"
        [maxChars]="200"
      [height]="200"></gymfinder-html-editor>
    </mat-card>

    <mat-card class="flex-grow flex-100 mat-card-margin-bottom">
      <mat-toolbar class="toolbar-subtitle no-margin-bottom">
        <mat-toolbar-row>Communication Preferences</mat-toolbar-row>
      </mat-toolbar>
      <mat-card-content>
        <gymfinder-transactional-emails [gym]="gym" [editMode]="editMode">
        </gymfinder-transactional-emails>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
